import { gqlTagGira } from '@atlassian/jira-apollo-gira';

export const PRIORITY_FRAGMENT = gqlTagGira`
    fragment jiraPriorityFieldFragment on JiraPriorityField {
        priority {
            id
            name
            priorityId
            iconUrl
        }
    }
`;
